import React from 'react';

function AppVersion() {
  if (process.env.NODE_ENV === 'development') {
    return (
      <div>
        Backend: &nbsp;
        {process.env.REACT_APP_BACKEND_BASE_URL}
      </div>
    );
  }

  return (
    <div>
      Build Version: &nbsp;
      {process.env.REACT_APP_VERSION}
    </div>
  );
}

export default AppVersion;
